import React from 'react';

const UpdateNotification = ({ onUpdate, onDismiss }) => {
  return (
    <div className="update-notification">
      <div className="update-notification-content">
        <div className="update-icon">🚀</div>
        <div className="update-text">
          <h3>New Version Available!</h3>
          <p>A new version of this app is available. Update now for the latest features and improvements.</p>
        </div>
        <div className="update-actions">
          <button className="update-btn update-now" onClick={onUpdate}>
            Update Now
          </button>
          <button className="update-btn dismiss" onClick={onDismiss}>
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;

